<template>
    <v-card flat>
        <s-crud :config="config" title="Detalle de Gastos/Ajustes" :filter="filter" add ref="scrudBudgetDetail"
            @save="saveDetail($event)" height="350px" search-input @rowSelected="rowSelected($event)">
            <template v-slot="props">
                <v-container fluid class="pa-0">
                    <div class="form-container-premium">

                        <div class="form-grid-3col">
                            <s-date label="Fecha de Registro *" v-model="props.item.BgdDate" required
                                @input="onDateChange(props.item)" />

                            <s-select :items="[{ text: 'COMPROMETIDO', value: 1 }, { text: 'EJECUTADO', value: 2 }]"
                                label="Estado del Detalle *" v-model="props.item.BdgState" required />

                            <s-select :items="[{ text: 'SOLES (PEN)', value: 1 }, { text: 'DÓLARES (USD)', value: 2 }]"
                                label="Moneda de Transacción *" v-model="props.item.BgdCurrencyType"
                                @input="onCurrencyChange($event, props.item)" required />

                            <!-- Monto único (USD o PEN según moneda) -->
                            <div class="form-group-premium">
                                <span class="label-premium">
                                    {{ props.item.BgdCurrencyType === 2 ? 'Monto (USD) *' : 'Monto (S/.) *' }}
                                </span>
                                <!-- <div class="cx-single-row"> -->
                                <!-- <span class="cx-badge"
                                        :class="props.item.BgdCurrencyType === 2 ? 'cx-badge-usd' : 'cx-badge-pen'">
                                        {{ props.item.BgdCurrencyType === 2 ? 'USD $' : 'PEN S/.' }}
                                    </span> -->
                                <div class="cx-input-box" style="flex: 1;">
                                    <input v-if="props.item.BgdCurrencyType === 2" type="number" step="0.01"
                                        class="cx-input cx-input-primary" placeholder="0.00"
                                        v-model="props.item.BgdAmountUSD"
                                        @input="onAmountUSDInput($event.target.value, props.item)" required />
                                    <input v-else type="number" step="0.01" class="cx-input cx-input-primary"
                                        placeholder="0.00" v-model="props.item.BgdAmount" required />
                                </div>
                                <!-- </div> -->
                            </div>
                        </div>

                        <div class="form-grid-3col">
                            <!-- Extras solo para DÓLARES: tipo de cambio + conversión al lado -->
                            <div v-if="props.item.BgdCurrencyType == 2" class="cx-dolar-extras">
                                <div class="form-group-premium">
                                    <span class="label-premium">Monto (Soles)</span>
                                    <div v-if="props.item.BgdAmountUSD > 0 && props.item.BgdRatePrice > 0"
                                        class="cx-conversion-banner">
                                        <v-icon size="12" color="#10b981" class="mr-1">mdi-swap-horizontal</v-icon>
                                        <span class="cx-conversion-label">S/.</span>
                                        <span class="cx-conversion-value">
                                            {{
                                                parseFloat((props.item.BgdAmountUSD *
                                                    props.item.BgdRatePrice).toFixed(3)).toLocaleString('es-PE', {
                                                        minimumFractionDigits: 2
                                                    })
                                            }}
                                        </span>
                                    </div>
                                    <div v-else class="cx-conversion-banner cx-conversion-empty">
                                        <span class="cx-conversion-label">S/.</span>
                                        <span class="cx-conversion-value" style="color: #94a3b8;">0.00</span>
                                    </div>
                                </div>
                            </div>

                            <div class="grid-span-2">
                                <s-text label="Descripción / Motivo *" v-model="props.item.BgdDescription" required />
                            </div>
                        </div>
                    </div>
                </v-container>
            </template>

            <!-- Personalización de columnas para un diseño súper moderno -->
            <template v-slot:BgdAmount="{ row }">
                <div class="text-left">
                    <span
                        :class="['font-weight-bold subtitle-1', isSubtract(row) ? 'red--text text--darken-2' : 'green--text text--darken-2']">
                        {{
                            budget?.BgtCurrencyType == 2 ?
                                formatMoney(row.BgdAmountUSD, row.BgdCurrencySymbol) :
                                formatMoney(row.BgdAmount, row.BgdCurrencySymbol)
                        }}
                    </span>

                    <span v-if="budget?.BgtCurrencyType != row.BgdCurrencyType || row.BgdCurrencyType == 2"
                        class="font-weight-bold caption">
                        {{
                            budget?.BgtCurrencyType == 2 ?
                                formatMoney(row.BgdAmount) :
                                formatMoney(row.BgdAmountUSD, '$US$')
                        }}
                    </span>
                </div>
            </template>

            <template v-slot:BdgStateName="{ row }">
                <div class="text-center">
                    <span :class="['custom-badge', row.BdgState == 2 ? 'badge-green' : 'badge-amber']">
                        {{ row.BdgStateName }}
                    </span>
                </div>
            </template>

            <template v-slot:BgdOperationTypeName="{ row }">
                <div class="text-center">
                    <span :class="['custom-badge', isSubtract(row) ? 'badge-red' : 'badge-green']">
                        <!-- <v-icon left :color="isSubtract(row) ? '#991b1b' : '#065f46'" class="mr-1"
                            style="font-size: 8px;">
                            {{ isSubtract(row) ? 'mdi-minus-thick' : 'mdi-plus-thick' }}
                        </v-icon> -->
                        {{ row.BgdOperationTypeName || '—' }}
                    </span>
                </div>
            </template>
        </s-crud>
    </v-card>
</template>

<script>
import _sBudgetDetail from '@/services/Treasury/TrsBudgetDetailService';
import _sOtherSupportService from "@/services/Security/OtherSupportService";
import { json } from 'd3';

export default {
    props: {
        bgtId: {
            type: Number,
            required: true
        },
        budget: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            tipoCambio: null,
            lastLoadedBgdID: null,
            filter: {
                BgtID: this.bgtId
            },
            config: {
                service: _sBudgetDetail,
                model: {
                    BgdID: "ID",
                    BgtID: "int",
                    BgdAmount: "decimal",
                    BgdAmountUSD: "decimal",
                    BgdCurrencyType: "int",
                    // BgdRatePrice: "decimal",
                    BgdOperationType: "int",
                    BdgState: "int",
                    BdgReference: "int",
                    BgdDate: "date",
                    BgdOperationTypeName: "string",
                    // SecStatus: "status"
                },
                headers: [
                    // { text: "ID", value: "BgdID" },
                    { text: "FECHA", value: "BgdDate" },
                    { text: "MONTO", value: "BgdAmount", align: "left", width: "130px" },
                    { text: "MONEDA", value: "BgdCurrencyName", align: "center", width: "120px" },
                    { text: "T/C", value: "BgdRatePrice", align: "center", width: "50px" },
                    { text: "DESCRIPCIÓN", value: "BgdDescription" },
                    { text: "CONCEPTO", value: "BdgReferenceName", align: "center" },
                    { text: "ESTADO", value: "BdgStateName", width: "100px", align: "center" },
                    // { text: "TIPO", value: "BgdOperationTypeName", width: "100px", align: "center" }
                ]
            }
        }
    },
    watch: {
        bgtId(newVal) {
            this.filter.BgtID = newVal;
            this.$refs.scrudBudgetDetail.refresh();
        }
    },
    methods: {
        rowSelected(item) {
            if (item && item.length > 0) {
                // console.log(JSON.parse(JSON.stringify(item[0])));
            }
        },
        async getExchangeRate(date, currencyType) {
            try {
                const result = await _sOtherSupportService.exchangeratesap(date, currencyType, this.$fun.getUserID());
                if (result.status == 200 && result.data && result.data.Rate) {
                    console.log("Tasa de cambio:", result.data);
                    return result.data.Rate;
                }
                return null;
            } catch (error) {
                console.log("Error al obtener la tasa de cambio:", error);
                return null;
            }
        },
        async onDateChange(item) {
            if (item && item.BgdDate) {
                // Se utiliza el tipo de cambio del presupuesto en lugar de consultar la fecha
                if (this.budget && this.budget.BgtRatePrice) {
                    this.tipoCambio = this.budget.BgtRatePrice;
                    this.$set(item, 'BgdRatePrice', this.budget.BgtRatePrice);
                    if (item.BgdCurrencyType == 2) {
                        const usd = parseFloat(item.BgdAmountUSD) || 0;
                        this.$set(item, 'BgdAmount', parseFloat((usd * this.budget.BgtRatePrice).toFixed(3)));
                    }
                } else {
                    const rate = await this.getExchangeRate(item.BgdDate, "US$");
                    if (rate) {
                        this.tipoCambio = rate;
                        this.$set(item, 'BgdRatePrice', rate);
                        if (item.BgdCurrencyType == 2) {
                            const usd = parseFloat(item.BgdAmountUSD) || 0;
                            this.$set(item, 'BgdAmount', parseFloat((usd * rate).toFixed(3)));
                        }
                    }
                }
            }
        },
        onCurrencyChange(type, item) {
            this.$set(item, 'BgdCurrencyType', type);
            if (this.budget && this.budget.BgtRatePrice) {
                this.tipoCambio = this.budget.BgtRatePrice;
                this.$set(item, 'BgdRatePrice', this.budget.BgtRatePrice);
            }
            if (type === 2) {
                if (!item.BgdRatePrice) {
                    this.$set(item, 'BgdRatePrice', this.tipoCambio);
                }
                const usd = parseFloat(item.BgdAmountUSD) || 0;
                const rate = parseFloat(item.BgdRatePrice) || this.tipoCambio;
                this.$set(item, 'BgdAmount', parseFloat((usd * rate).toFixed(3)));
            }
        },
        onRatePriceInput(value, item) {
            const rate = parseFloat(value);
            this.$set(item, 'BgdRatePrice', value);
            if (rate > 0) {
                const usd = parseFloat(item.BgdAmountUSD);
                if (!isNaN(usd) && usd > 0) {
                    this.$set(item, 'BgdAmount', parseFloat((usd * rate).toFixed(3)));
                }
            }
        },
        onAmountPENInput(value, item) {
            const soles = parseFloat(value);
            this.$set(item, 'BgdAmount', value);
            if (this.budget && this.budget.BgtRatePrice) {
                this.tipoCambio = this.budget.BgtRatePrice;
                this.$set(item, 'BgdRatePrice', this.budget.BgtRatePrice);
            }
            const rate = parseFloat(item.BgdRatePrice) || this.tipoCambio;
            if (!isNaN(soles) && !isNaN(rate) && rate > 0) {
                this.$set(item, 'BgdAmountUSD', parseFloat((soles / rate).toFixed(3)));
            }
        },
        onAmountUSDInput(value, item) {
            const usd = parseFloat(value);
            this.$set(item, 'BgdAmountUSD', value);
            if (this.budget && this.budget.BgtRatePrice) {
                this.tipoCambio = this.budget.BgtRatePrice;
                this.$set(item, 'BgdRatePrice', this.budget.BgtRatePrice);
            }
            const rate = parseFloat(item.BgdRatePrice) || this.tipoCambio;
            if (!isNaN(usd) && !isNaN(rate) && rate > 0) {
                this.$set(item, 'BgdAmount', parseFloat((usd * rate).toFixed(3)));
            }
        },
        saveDetail(item) {
            if (item.BgdDate == null || item.BgdDate == "") {
                this.$fun.alert("Debe seleccionar una fecha", "warning");
                return;
            }

            if (item.BdgState == null || item.BdgState == "" || item.BdgState <= 0) {
                this.$fun.alert("Debe seleccionar un estado", "warning");
                return;
            }

            if (!item.BgdCurrencyType || item.BgdCurrencyType == 0) {
                this.$fun.alert("Debe seleccionar un tipo de moneda", "warning");
                return;
            }

            if (item.BgdAmount == null || item.BgdAmount <= 0) {
                this.$fun.alert("Debe ingresar un monto en S/. mayor a 0", "warning");
                return;
            }

            if (item.BgdCurrencyType == 2 && (item.BgdAmountUSD == null || item.BgdAmountUSD <= 0)) {
                this.$fun.alert("Debe ingresar un monto en US$ mayor a 0", "warning");
                return;
            }

            // Forzar tipo de cambio del presupuesto actual
            if (this.budget && this.budget.BgtRatePrice) {
                this.tipoCambio = this.budget.BgtRatePrice;
                this.$set(item, 'BgdRatePrice', this.budget.BgtRatePrice);
            }

            if (!item.BgdRatePrice || Number(item.BgdRatePrice) <= 0) {
                this.$fun.alert("El presupuesto no tiene un tipo de cambio registrado", "warning");
                return;
            }

            if (item.BgdDescription == null || item.BgdDescription.trim() == "") {
                this.$fun.alert("Debe ingresar una descripción", "warning");
                return;
            }

            // — Validación de saldo disponible —
            if (this.budget) {
                const saldoDisponible = parseFloat(this.budget.BgtAvailableBalance) || 0;
                const rate = parseFloat(item.BgdRatePrice) || 1;
                const montoSoles = item.BgdCurrencyType == 2 ? (parseFloat(item.BgdAmount) * rate) : parseFloat(item.BgdAmount);

                if (saldoDisponible <= 0) {
                    this.$fun.alert(`No hay saldo contable disponible para registrar este gasto.\n` + `Saldo actual: S/. ${saldoDisponible.toFixed(3)}`, "warning");
                    return;
                }

                if (montoSoles > saldoDisponible) {
                    this.$fun.alert(`El monto ingresado (S/. ${montoSoles.toFixed(3)}) supera el saldo contable disponible.\n` + `Saldo disponible: S/. ${saldoDisponible.toFixed(3)}`, "warning");
                    return;
                }
            }

            item.SecStatus = 1;
            item.BgtID = this.bgtId;
            item.BdgReqID = null; // ID Requerimiento
            item.BdgReference = 1;
            item.BdgReferenceID = null; // ID linea del requerimiento
            item.BgdOperationType = 1; // 1: RESTA, 2: SUMA
            console.log(JSON.parse(JSON.stringify(item)))
            const cleanItem = { ...item };
            if (cleanItem.BgdCurrencyType == 2) {
                cleanItem.BgdAmountUSD = cleanItem.BgdAmount;
                cleanItem.BgdAmount = (cleanItem.BgdAmountUSD * cleanItem.BgdRatePrice).toFixed(3);
            }

            cleanItem.save().then(() => {
                this.$emit('saved');
            });
        },
        isSubtract(item) {
            if (!item) return false;
            return item.BgdOperationType == 1 ? true : false;
        },
        formatMoney(value, simbolo) {
            const sym = simbolo || 'S/.';
            if (value == null || isNaN(value)) return sym + " 0.00";
            return sym + Number(value).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    },
    async created() {
        if (this.budget && this.budget.BgtRatePrice) {
            this.tipoCambio = this.budget.BgtRatePrice;
        } else {
            const rate = await this.getExchangeRate(new Date(), "US$");
            if (rate) {
                this.tipoCambio = rate;
            }
        }
    },
    mounted() {
        // Observador para inicializar los valores del formulario de edición / nuevo registro de forma segura
        this.$watch(
            () => this.$refs.scrudBudgetDetail ? [this.$refs.scrudBudgetDetail.showForm, this.$refs.scrudBudgetDetail.row] : null,
            ([showForm, newRow]) => {
                if (showForm && newRow) {
                    if (this.lastLoadedBgdID != newRow.BgdID || !newRow.BgdCurrencyType) {
                        this.lastLoadedBgdID = newRow.BgdID;

                        if (!newRow.BgdCurrencyType) {
                            this.$set(newRow, 'BgdCurrencyType', 1);
                        }

                        if (this.budget) {
                            this.$set(newRow, 'BgdCurrencyType', this.budget.BgtCurrencyType);
                            if (this.budget.BgtRatePrice) {
                                this.tipoCambio = this.budget.BgtRatePrice;
                                this.$set(newRow, 'BgdRatePrice', this.budget.BgtRatePrice);
                            }
                        }

                        if (newRow.BgdCurrencyType == 2) {
                            if (!newRow.BgdRatePrice) {
                                this.$set(newRow, 'BgdRatePrice', this.tipoCambio);
                            }
                            const usd = parseFloat(newRow.BgdAmountUSD) || 0;
                            const rate = parseFloat(newRow.BgdRatePrice) || this.tipoCambio;
                            this.$set(newRow, 'BgdAmount', parseFloat((usd * rate).toFixed(3)));
                        }
                    }
                } else if (!showForm) {
                    this.lastLoadedBgdID = null;
                }
            },
            { deep: false }
        );
    }
}
</script>

<style scoped>
/* Badges Modernos (SaaS 2026 Style) */
.custom-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 5px;
    font-size: 9px;
    font-weight: 700;
    border-radius: 4px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    width: max-content;
}

.badge-blue {
    background-color: #eff6ff;
    color: #1e40af;
    border: 1px solid #bfdbfe;
}

.badge-purple {
    background-color: #f5f3ff;
    color: #5b21b6;
    border: 1px solid #ddd6fe;
}

.badge-orange {
    background-color: #fff7ed;
    color: #9a3412;
    border: 1px solid #fed7aa;
}

.badge-amber {
    background-color: #fffbeb;
    color: #92400e;
    border: 1px solid #fde68a;
}

.badge-green {
    background-color: #ecfdf5;
    color: #065f46;
    border: 1px solid #a7f3d0;
}

.badge-red {
    background-color: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

.badge-grey {
    background-color: #f8fafc;
    color: #64748b;
    border: 1px solid #e2e8f0;
}

.slate--text {
    color: #334155;
}

/* Modificaciones de Estilo para s-crud y v-data-table */
::v-deep .v-data-table {
    border: 1px solid #e2e8f0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
}

::v-deep .v-data-table-header th {
    background-color: #f8fafc !important;
    color: #64748b !important;
    font-size: 11px !important;
    font-weight: 800 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    height: 40px !important;
    border-bottom: 1px solid #e2e8f0 !important;
}

::v-deep .v-data-table tbody td {
    font-size: 13px !important;
    color: #334155 !important;
    height: 44px !important;
    border-bottom: 1px solid #f1f5f9 !important;
}

::v-deep .v-data-table tbody tr:hover {
    background-color: #f8fafc !important;
}

/* Personalización para los Inputs en el formulario de edición */
::v-deep .v-text-field--outlined fieldset {
    border-color: #cbd5e1 !important;
    border-radius: 8px !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: #2563eb !important;
}



/* ─── COMPACT FINTECH CURRENCY ROW (2026) ─── */
.cx-row {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 6px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 6px 10px;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.cx-row:focus-within {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.07);
    background: #ffffff;
}

.cx-row-single {
    grid-template-columns: 1fr;
}

.cx-cell {
    display: flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
}

.cx-cell-full {
    width: 100%;
}

.cx-pen {
    border-left: 3px solid #10b981;
    padding-left: 8px;
    border-radius: 2px;
}

.cx-usd {
    border-left: 3px solid #3b82f6;
    padding-left: 8px;
    border-radius: 2px;
}

.cx-badge {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    padding: 2px 7px;
    border-radius: 5px;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.04em;
    color: #fff;
    white-space: nowrap;
}

.cx-badge-pen {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
}

.cx-badge-usd {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

/* Wrapper que da apariencia de input editable */
.cx-input-box {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    background: #ffffff;
    border: 1.5px solid #cbd5e1;
    border-radius: 7px;
    padding: 4px 8px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.cx-input-box:focus-within {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.cx-input-box-primary {
    border-color: #93c5fd;
    background: #f0f7ff;
}

.cx-input-box-primary:focus-within {
    border-color: #2563eb;
    background: #ffffff;
}

.cx-input {
    width: 100%;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    font-family: Consolas, Monaco, monospace;
    padding: 0;
    cursor: text;
}

.cx-input::placeholder {
    color: #94a3b8;
    font-weight: 400;
}

.cx-input-primary {
    color: #1e3a8a;
}

.cx-hint {
    flex-shrink: 0;
    font-size: 8.5px;
    font-weight: 500;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
}

.cx-swap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 50%;
    flex-shrink: 0;
    transition: transform 0.35s ease, background 0.2s ease;
}

.cx-row:hover .cx-swap {
    transform: rotate(180deg);
    background: #dbeafe;
}

/* Campo único de monto en 3ª columna */
.cx-single-row {
    display: flex;
    align-items: center;
    gap: 7px;
}

/* Bloque extras para modo DÓLARES: en fila compacta */
.cx-dolar-extras {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.cx-rate-input {
    width: 140px;
    flex-shrink: 0;
}

/* Banner de conversión a soles */
.cx-conversion-banner {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    background: linear-gradient(135deg, #ecfdf5, #d1fae5);
    border: 1px solid #6ee7b7;
    border-radius: 7px;
    font-size: 11px;
    width: 100%;
    /* width: fit-content; */
}

.cx-conversion-empty {
    background: #f8fafc !important;
    border-color: #e2e8f0 !important;
}

.cx-conversion-label {
    color: #047857;
    font-weight: 600;
}

.cx-conversion-value {
    color: #064e3b;
    font-weight: 800;
    font-family: Consolas, Monaco, monospace;
}

/* Estructura del Formulario */
.form-container-premium {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form-grid-2col {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 8px;
}

.form-grid-3col {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 8px;
}

.form-group-premium {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.label-premium {
    font-size: 10px;
    font-weight: 700;
    color: #64748b;
    letter-spacing: 0.05em;
}

.grid-span-2 {
    grid-column: span 2;
}

@media (max-width: 600px) {

    .form-grid-2col,
    .form-grid-3col {
        grid-template-columns: 1fr;
    }

    .grid-span-2 {
        grid-column: span 1;
    }

    .currency-bridge-grid {
        grid-template-columns: 1fr;
        gap: 6px;
    }

    .bridge-connector {
        transform: rotate(90deg);
        margin: 6px 0;
    }
}
</style>
